<template>
  <div class="index-legend">
    <div class="d-flex align-center mb-1">
      <span class="font-weight-bold black--text">{{ indexType }} {{ $t("reports.cropProgression.scale") }}</span>
      <v-icon small color="primary" class="ml-1">mdi-information-outline</v-icon>
    </div>

    <!-- Colorbar: use the Python-provided image if available, else a CSS gradient -->
    <img
      v-if="meta.image_url"
      :src="meta.image_url"
      alt="scale"
      class="colorbar-img"
    />
    <div v-else class="colorbar-gradient">
      <div class="ticks">
        <span>-1</span><span>0</span><span>1</span>
      </div>
    </div>

    <div class="scale-note grey--text text--darken-2 mt-1">
      {{ meta.scale_note_2 || $t("reports.cropProgression.valuesCloseToOne") }}
    </div>

    <div v-if="label" class="font-weight-bold black--text mt-4">{{ label }}</div>

    <ol v-if="descriptions.length" class="desc-list mt-2">
      <li v-for="(d, i) in descriptions" :key="i">{{ d }}</li>
    </ol>

    <div v-if="meta.note" class="note mt-2 black--text">
      <strong>{{ meta.note }}</strong>
    </div>
  </div>
</template>

<script>
export default {
  name: "IndexLegend",
  props: {
    indexType: { type: String, required: true },
    // full metadata object keyed by index name (from getIndicesMetadata)
    metadata: { type: Object, default: () => ({}) },
    label: { type: String, default: "" },
  },
  computed: {
    meta() {
      return (this.metadata && this.metadata[this.indexType]) || {};
    },
    descriptions() {
      return Array.isArray(this.meta.description) ? this.meta.description : [];
    },
  },
};
</script>

<style scoped>
.colorbar-img {
  width: 100%;
  max-width: 500px;
  height: auto;
  display: block;
}
.colorbar-gradient {
  width: 100%;
  max-width: 500px;
  height: 22px;
  border-radius: 3px;
  background: linear-gradient(
    to right,
    #a50026,
    #d73027,
    #f46d43,
    #fdae61,
    #fee08b,
    #ffffbf,
    #d9ef8b,
    #a6d96a,
    #66bd63,
    #1a9850,
    #006837
  );
  position: relative;
}
.colorbar-gradient .ticks {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #494949;
  margin-top: 2px;
}
.scale-note {
  font-size: 12px;
}
.desc-list li {
  margin: 4px 0 4px 4px;
  font-size: 13px;
  color: #333;
}
.note {
  font-size: 12px;
}
</style>
